import { arrayRequired, labeled } from '../../util/joi';
import { schema as reviewProductsProductSplitsSchema } from './HomeLoanReviewProductsProductSplits.schema';

export const schema = (Joi: any, label: string) =>
  arrayRequired(Joi, reviewProductsProductSplitsSchema(Joi, labeled(label, 'Split -')))
    .min(1)
    .label(labeled(label, 'Split -'));

export default {
  schema
};
